// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    buttonText: "Contact sales",
    case1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-1.avif",
        alt: ""
    },
    case1Link: "See the case study",
    case1Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734d99fde1ee8d76038_logo-height-mcdonalds.svg",
        alt: ""
    },
    case1Number: "615%",
    case1Tag: "Retail & CPG",
    case1Text: "Return on investment",
    case2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-2.avif",
        alt: ""
    },
    case2Link: "See the case study",
    case2Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg",
        alt: ""
    },
    case2Number: "105K",
    case2Tag: "Manufacturing",
    case2Text: "Hours saved annually ",
    case2UrlLink: {
        href: "https://www.youtube.com/watch?v=OU1IVTMX4ZI",
        target: "_self"
    },
    case3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-3.avif",
        alt: ""
    },
    case3Link: "See the case study",
    case3Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg",
        alt: ""
    },
    case3Number: "300%",
    case3Tag: "Advertising",
    case3Text: "Saved yearly to reinvest",
    case3UrlLink: {
        href: "https://monday.com/w/customer-stories/canva",
        target: "_self"
    },
    case4Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-4.avif",
        alt: ""
    },
    case4Link: "See the case study",
    case4Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg",
        alt: ""
    },
    case4Number: "28%",
    case4Tag: "Technology",
    case4Text: "Faster time to market",
    case4UrlLink: {
        href: "https://monday.com/w/customer-stories/vistra",
        target: "_self"
    },
    case5Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-5.avif",
        alt: ""
    },
    case5Link: "See the case study",
    case5Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685997346fd24ab09e1a1264_logo-height-universal.svg",
        alt: ""
    },
    case5Number: "517%",
    case5Tag: "Entertainment",
    case5Text: "Growth in annual accounts",
    case5UrlLink: {
        href: "https://www.youtube.com/watch?v=qytqG3VwLlg",
        target: "_self"
    },
    case6Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-6.avif",
        alt: ""
    },
    case6Link: "See the case study",
    case6Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734e774c48a76e64d64_logo-height-compass.svg",
        alt: ""
    },
    case6Number: "$173K",
    case6Tag: "Real estate",
    case6Text: "Saved per month",
    case6UrlLink: {
        href: "https://monday.com/w/customer-stories/compass",
        target: "_self"
    },
    case7Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-7.avif",
        alt: ""
    },
    case7Link: "See the case study",
    case7Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg",
        alt: ""
    },
    case7Number: "$250K",
    case7Tag: "Advertising",
    case7Text: "Saved yearly to reinvest",
    case7UrlLink: {
        href: "https://monday.com/w/customer-stories/vml",
        target: "_self"
    },
    case8Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-8.avif",
        alt: ""
    },
    case8Link: "See the case study",
    case8Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734626e8d76fb98b8ef_logo-height-callbox.svg",
        alt: ""
    },
    case8Number: "66%",
    case8Tag: "Technology",
    case8Text: "Decrease in post-release bugs",
    case8UrlLink: {
        href: "https://monday.com/w/customer-stories/call-box",
        target: "_self"
    },
    case9Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-9.avif",
        alt: ""
    },
    case9Link: "See the case study",
    case9Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685997344e69395c270955c1_logo-height-deezer.svg",
        alt: ""
    },
    case9Number: "142%",
    case9Tag: "Technology",
    case9Text: "More weekly campaigns",
    case9UrlLink: {
        href: "https://monday.com/w/customer-stories/deezer",
        target: "_self"
    },
    title: "Brands who trust monday.com to accelerate their business outcomes "
};
